/**
 * Observations Service
 * Observations management API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateObservationRequestDtoValueData } from './createObservationRequestDtoValueData';


export interface UpdateObservationRequestDto { 
    /**
     * Observation status
     */
    status?: UpdateObservationRequestDto.StatusEnum;
    /**
     * Effective date-time in ISO 8601 format
     */
    effectiveDateTime?: string;
    /**
     * Issued date-time in ISO 8601 format
     */
    issuedDateTime?: string;
    /**
     * Type of the observation value
     */
    valueType?: UpdateObservationRequestDto.ValueTypeEnum;
    valueData?: CreateObservationRequestDtoValueData;
    /**
     * Component observations for panel results
     */
    components?: Array<any>;
    /**
     * Interpretation code
     */
    interpretation?: string;
    /**
     * Reference range text
     */
    referenceRange?: string;
    /**
     * Additional notes
     */
    note?: string;
    /**
     * Metadata conforming to element recordSchema (partial update)
     */
    metadata?: any;
}
export namespace UpdateObservationRequestDto {
    export type StatusEnum = 'open' | 'closed' | 'on-hold';
    export const StatusEnum = {
        Open: 'open' as StatusEnum,
        Closed: 'closed' as StatusEnum,
        OnHold: 'on-hold' as StatusEnum
    };
    export type ValueTypeEnum = 'quantity' | 'string' | 'boolean' | 'integer' | 'time' | 'dateTime' | 'period' | 'range' | 'ratio';
    export const ValueTypeEnum = {
        Quantity: 'quantity' as ValueTypeEnum,
        String: 'string' as ValueTypeEnum,
        Boolean: 'boolean' as ValueTypeEnum,
        Integer: 'integer' as ValueTypeEnum,
        Time: 'time' as ValueTypeEnum,
        DateTime: 'dateTime' as ValueTypeEnum,
        Period: 'period' as ValueTypeEnum,
        Range: 'range' as ValueTypeEnum,
        Ratio: 'ratio' as ValueTypeEnum
    };
}


